@if (review()) {
	<div class="mt-8" [ngClass]="{ 'px-2 pb-2 bg-uc-blue-900 rounded-md': topReview() }">
		@if (topReview()) {
			<p class="py-4 text-lg font-bold text-white md:pl-4">Top Student Review</p>
		}
		<div
			class="relative p-0 bg-white border rounded-lg"
			[ngClass]="{
				'rounded-lg': !review().reply,
				'rounded-t-lg rounded-bl-lg': review().reply,
			}"
		>
			<!-- review header -->
			<uc-review-header
				[review]="review()"
				[avatar]="avatar"
				[searchTerm]="inputValue$ | async"
			/>
			<!-- review content-->
			<div
				class="p-2 text-gray-500 md:p-6"
				[innerHtml]="
					review().comment
						| ucEntities
						| highlightSearch: (inputValue$ | async)!
				"
			></div>
			<div class="flex items-center justify-between px-2 py-4 border-t md:p-6">
				<!-- UPVOTE & DOWNVOTE  -->
				<uc-review-reaction
					[reviewId]="review().id"
					[reaction]="review().reaction"
					[likes]="review().likes"
					[dislikes]="review().dislikes"
					(reviewReaction)="onReviewReaction($event)"
				/>
				<!-- report / share  -->
				<uc-review-three-dots (showModalPanel)="showModalPanel($event)" />
			</div>
		</div>
		<!-- university reply -->
		@if (review().reply) {
			<div
				class="px-4 py-4 ml-8 border-b border-l border-r rounded-b-lg bg-gray-50 sm:px-6"
			>
				<span class="text-sm text-gray-500">
					Reply from:
					<span class="capitalize">{{ universityName() }}</span>
				</span>
				<p class="text-lg italic text-gray-700" [innerHtml]="review().reply"></p>
			</div>
		}
	</div>
}
